var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcInvoicesDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 34.005,
  height: 34.005,
  viewBox: "0 0 34.005 34.005",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M0-24H34V10H0Z",
  transform: "translate(0 24)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M5.417-22H25.253a1.417,1.417,0,0,1,1.417,1.417V4.92a1.417,1.417,0,0,1-1.417,1.417H5.417A1.417,1.417,0,0,1,4,4.92v-25.5A1.417,1.417,0,0,1,5.417-22Z",
  transform: "translate(-4 22)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M7-18v1.417h7.084V-18Z",
  transform: "translate(-7 18)",
  fill: "#5f7278",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M7-12v1.417H21.169V-12Z",
  transform: "translate(-7 12)",
  fill: "#5f7278",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M7-15v1.417h5.667V-15Z",
  transform: "translate(-7 15)",
  fill: "#5f7278",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M7-9v1.417H18.335V-9Z",
  transform: "translate(-7 9)",
  fill: "#5f7278",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M7-6v1.417h8.5V-6Z",
  transform: "translate(-7 6)",
  fill: "#5f7278",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-8"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M16.906-13.589a.714.714,0,0,0-.294-.578,2.864,2.864,0,0,0-.993-.425,3.43,3.43,0,0,1-1.418-.632,1.258,1.258,0,0,1-.445-.99,1.287,1.287,0,0,1,.436-1,2.04,2.04,0,0,1,1.2-.466V-18.5h.68v.82a1.9,1.9,0,0,1,1.194.526,1.656,1.656,0,0,1,.427,1.2h-.84a1.136,1.136,0,0,0-.306-.835,1.109,1.109,0,0,0-.826-.309,1.307,1.307,0,0,0-.831.229.772.772,0,0,0-.288.639.716.716,0,0,0,.3.606,3.067,3.067,0,0,0,1,.41,4.688,4.688,0,0,1,1.087.406,1.579,1.579,0,0,1,.575.516,1.27,1.27,0,0,1,.185.69,1.252,1.252,0,0,1-.463,1.014,2.3,2.3,0,0,1-1.3.455v.712h-.676v-.712a2.181,2.181,0,0,1-1.331-.494,1.489,1.489,0,0,1-.482-1.169h.845a.983.983,0,0,0,.333.8,1.43,1.43,0,0,0,.945.28,1.642,1.642,0,0,0,.941-.235A.738.738,0,0,0,16.906-13.589Z",
  transform: "translate(-13.5 18.5)",
  fill: "none",
  clipRule: "evenodd"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_92",
  "data-name": "Group 92",
  transform: "translate(0 24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_92-2",
  "data-name": "Group 92",
  transform: "translate(0 -24)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M-5-29H43.173V19.173H-5Z",
  transform: "translate(-2.084 21.916)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(5.667 -21.166)",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M1.417,0H21.253A1.417,1.417,0,0,1,22.67,1.417v25.5a1.417,1.417,0,0,1-1.417,1.417H1.417A1.417,1.417,0,0,1,0,26.92V1.417A1.417,1.417,0,0,1,1.417,0Z",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_95",
  "data-name": "Group 95",
  transform: "translate(9.918 -15.499)",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M2-23H23.253V-7.414H2Z",
  transform: "translate(-9.084 15.916)",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_96",
  "data-name": "Group 96",
  transform: "translate(9.918 -6.998)",
  clipPath: "url(#clip-path-4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M2-17H30.337V-1.414H2Z",
  transform: "translate(-9.084 9.916)",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_97",
  "data-name": "Group 97",
  transform: "translate(9.918 -11.248)",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M2-20H21.836V-4.414H2Z",
  transform: "translate(-9.084 12.916)",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_98",
  "data-name": "Group 98",
  transform: "translate(9.918 -2.747)",
  clipPath: "url(#clip-path-6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M2-14H27.5V1.586H2Z",
  transform: "translate(-9.084 6.916)",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_99",
  "data-name": "Group 99",
  transform: "translate(9.918 1.504)",
  clipPath: "url(#clip-path-7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M2-11H24.67V4.586H2Z",
  transform: "translate(-9.084 3.916)",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_100",
  "data-name": "Group 100",
  transform: "translate(19.128 -16.207)",
  clipPath: "url(#clip-path-8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M8.5-23.5H26.919V-2.247H8.5Z",
  transform: "translate(-15.584 16.416)",
  fill: "#5f7278"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101",
  transform: "translate(19.128 -16.207)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M3.406,4.911a.714.714,0,0,0-.294-.578,2.863,2.863,0,0,0-.993-.425A3.431,3.431,0,0,1,.7,3.276a1.258,1.258,0,0,1-.445-.99,1.287,1.287,0,0,1,.436-1A2.04,2.04,0,0,1,1.89.817V0h.68V.82a1.9,1.9,0,0,1,1.194.526,1.656,1.656,0,0,1,.427,1.2h-.84a1.136,1.136,0,0,0-.306-.835,1.109,1.109,0,0,0-.826-.309,1.307,1.307,0,0,0-.831.229.772.772,0,0,0-.288.639.717.717,0,0,0,.3.606,3.067,3.067,0,0,0,1,.41A4.689,4.689,0,0,1,3.49,3.7a1.579,1.579,0,0,1,.575.516,1.27,1.27,0,0,1,.185.69,1.252,1.252,0,0,1-.463,1.014,2.3,2.3,0,0,1-1.3.455v.712H1.813V6.372A2.181,2.181,0,0,1,.482,5.878,1.489,1.489,0,0,1,0,4.709H.845a.983.983,0,0,0,.333.8,1.43,1.43,0,0,0,.945.28,1.642,1.642,0,0,0,.941-.235A.738.738,0,0,0,3.406,4.911Z",
  fill: "none",
  stroke: "#5f7278",
  strokeWidth: 0.3
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcInvoicesDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_invoices_dashboard.c9d2abe08211b26be6f4dfcb6018d9cd.svg";